<template>
  <div class="weather-daily">
    <div v-if="!isMobile" class="weather-daily__horizontal">
      <EForecastCarousel :is-mobile="isMobile">
        <EForecastItem
          v-for="(day, index) in forecast"
          v-bind="getDetails(day)"
          :key="day.time.toString()"
          :selected="index === selected"
          data-test-id="forecast-item"
          selectable
          @click="select(index)"
        />
      </EForecastCarousel>
    </div>
    <div v-else class="weather-daily__vertical">
      <button
        v-if="!expanded"
        :aria-expanded="expanded.toString()"
        aria-controls="weather-daily-vertical"
        class="weather-daily__heading"
        data-test-id="weather-daily-heading"
        @click="expand"
        @keypress.enter.space="expand"
      >
        {{ $t('web.widgets.weather.weekly') }}
        <div class="weather-daily__heading-caret">
          <EIcon icon="chevron-down" size="s" />
        </div>
      </button>
      <!-- TODO: add back expand transition -->
      <ul
        v-show="expanded"
        id="weather-daily-vertical"
        ref="vertical"
        :aria-label="$t('web.widgets.weather.forecast.title')"
        data-test-id="weather-daily-vertical"
        class="weather-daily__rows"
      >
        <EForecastRow
          v-for="(day, index) in forecast"
          v-bind="getDetails(day)"
          :key="day.time.toString()"
          :selected="index === selected"
          data-test-id="forecast-row"
          @click="select(index)"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import upperFirst from 'lodash/upperFirst';

import EIcon from '~~/common/vue/components/icon';
import EForecastRow from './row';
import EForecastCarousel from './carousel';
import EForecastItem from './item';

export default {
  name: 'EDailyForecast',
  components: {
    EForecastRow,
    EForecastCarousel,
    EForecastItem,
    EIcon,
  },
  props: {
    forecast: {
      type: Array,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
    selected: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    ...mapState('global', ['locale']),
  },
  methods: {
    expand() {
      if (this.isMobile) {
        this.expanded = true;
        this.$refs.vertical.focus();
        this.$emit('expand-daily');
      }
    },
    select(index) {
      this.$emit('select', index);
    },
    getDetails(day) {
      const itemDate = day.time;
      itemDate.setHours(12);

      return {
        code: day.code,
        time: itemDate,
        description: day.description,
        label: upperFirst(day.time.toLocaleDateString(this.locale, { weekday: 'long' })),
        secondaryTemperature: day.minTemperature,
        sunrise: day.sunrise,
        sunset: day.sunset,
        temperature: day.maxTemperature,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.weather-daily__vertical {
  @include divider('top');

  margin: 0 (-1 * $space-s) (-1 * $space-m);
  padding-top: $space-1s;
  padding-bottom: $space-1s;
}

.weather-daily__horizontal {
  padding: $space-1s 0;
}

.weather-daily__heading {
  background: inherit;
  border: none;
  color: inherit;
  line-height: inherit;
  width: 100%;
  padding: $space-1s $space-l;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.weather-daily__heading-caret {
  text-align: right;
}

.weather-daily__rows {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
</style>
